export default __webpack_public_path__ + "static/media/github.11971f4c.svg";